// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.restrict-card {
  background-color: #ededeb;
  height: 6.6vw;
  width: 14.4vw;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.5vw;
  border-radius: 0.4vw;
}

.left-section {
  display: flex;
  align-items: center;
  column-gap: 0.25vw;
  p {
    color: black;
    font-weight: 700;
    font-size: 0.7vw;
    font-family: "Poppins";
  }
}

.left-section div {
  display: flex;
  align-items: center;
  gap: 0.15vw;
  span {
    display: flex;
    align-items: center;
    white-space: nowrap;
    letter-spacing: 0%;
    /* margin-bottom: 0.2vw; */
  }
}

.right-section {
  width: 5.5vw;
  height: 5.5vw;
  border-radius: 0.15vw;
}
`, "",{"version":3,"sources":["webpack://./src/components/ui/cards/restrictedCard/RestrictedStyle.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,aAAa;EACb,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB;IACE,YAAY;IACZ,gBAAgB;IAChB,gBAAgB;IAChB,sBAAsB;EACxB;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX;IACE,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;IAClB,0BAA0B;EAC5B;AACF;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,qBAAqB;AACvB","sourcesContent":[".restrict-card {\n  background-color: #ededeb;\n  height: 6.6vw;\n  width: 14.4vw;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 0.5vw;\n  border-radius: 0.4vw;\n}\n\n.left-section {\n  display: flex;\n  align-items: center;\n  column-gap: 0.25vw;\n  p {\n    color: black;\n    font-weight: 700;\n    font-size: 0.7vw;\n    font-family: \"Poppins\";\n  }\n}\n\n.left-section div {\n  display: flex;\n  align-items: center;\n  gap: 0.15vw;\n  span {\n    display: flex;\n    align-items: center;\n    white-space: nowrap;\n    letter-spacing: 0%;\n    /* margin-bottom: 0.2vw; */\n  }\n}\n\n.right-section {\n  width: 5.5vw;\n  height: 5.5vw;\n  border-radius: 0.15vw;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
